import React from 'react'
import { shallow } from 'enzyme'

import { PopupMessage } from '../../components'

describe('PopupMessage', () => { 
  let wrapper, props

  beforeAll(() => {
    props = {
      closeAction: () => {
        return 'close'
      }
    }
    wrapper = shallow(<PopupMessage {...props}>test</PopupMessage>)
  })

  describe("#render", () => {
    it("renders", () => {
      expect(wrapper).toBeTruthy()
    })
  })
})
